/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_VERIFICATIONS, GET_VERIFICATIONS_BY_VERIFICATION_ID, POST_VERIFICATIONS_LINK_FILE, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK, SET_DOCUMENTS_SUBMITTED, SET_FORM } from './actionTypes';
/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */

var fetchVerificationsReducer = function fetchVerificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, FETCH_VERIFICATIONS);
};
/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var isFetchingFetchVerificationsReducer = function isFetchingFetchVerificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, FETCH_VERIFICATIONS);
};
/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var fetchVerificationsErrorReducer = function fetchVerificationsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, FETCH_VERIFICATIONS);
};
/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var getVerificationsByVerificationIdReducer = function getVerificationsByVerificationIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);
};
/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var isFetchingGetVerificationsByVerificationIdReducer = function isFetchingGetVerificationsByVerificationIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);
};
/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var getVerificationsByVerificationIdErrorReducer = function getVerificationsByVerificationIdErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);
};
/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var postVerificationsLinkFileReducer = function postVerificationsLinkFileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, POST_VERIFICATIONS_LINK_FILE);
};
/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var isFetchingPostVerificationsLinkFileReducer = function isFetchingPostVerificationsLinkFileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, POST_VERIFICATIONS_LINK_FILE);
};
/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var postVerificationsLinkFileErrorReducer = function postVerificationsLinkFileErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, POST_VERIFICATIONS_LINK_FILE);
};
/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var deleteVerificationsFileLinksByLinkIdReducer = function deleteVerificationsFileLinksByLinkIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);
};
/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var isFetchingDeleteVerificationsFileLinksByLinkIdReducer = function isFetchingDeleteVerificationsFileLinksByLinkIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);
};
/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var deleteVerificationsFileLinksByLinkIdErrorReducer = function deleteVerificationsFileLinksByLinkIdErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);
};
/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var postVerificationsCreateCaseworkerTaskReducer = function postVerificationsCreateCaseworkerTaskReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);
};
/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


var isFetchingPostVerificationsCreateCaseworkerTaskReducer = function isFetchingPostVerificationsCreateCaseworkerTaskReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);
};
/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var postVerificationsCreateCaseworkerTaskErrorReducer = function postVerificationsCreateCaseworkerTaskErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);
};
/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var setDocumentsSubmittedReducer = function setDocumentsSubmittedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: SET_DOCUMENTS_SUBMITTED
  });
};
/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */


var setFormReducer = function setFormReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: SET_FORM
  });
};

var reducers = combineReducers({
  fetchVerifications: fetchVerificationsReducer,
  isFetchingFetchVerifications: isFetchingFetchVerificationsReducer,
  fetchVerificationsError: fetchVerificationsErrorReducer,
  getVerificationsByVerificationId: getVerificationsByVerificationIdReducer,
  isFetchingGetVerificationsByVerificationId: isFetchingGetVerificationsByVerificationIdReducer,
  getVerificationsByVerificationIdError: getVerificationsByVerificationIdErrorReducer,
  postVerificationsLinkFile: postVerificationsLinkFileReducer,
  isFetchingPostVerificationsLinkFile: isFetchingPostVerificationsLinkFileReducer,
  postVerificationsLinkFileError: postVerificationsLinkFileErrorReducer,
  deleteVerificationsFileLinksByLinkId: deleteVerificationsFileLinksByLinkIdReducer,
  isFetchingDeleteVerificationsFileLinksByLinkId: isFetchingDeleteVerificationsFileLinksByLinkIdReducer,
  deleteVerificationsFileLinksByLinkIdError: deleteVerificationsFileLinksByLinkIdErrorReducer,
  postVerificationsCreateCaseworkerTask: postVerificationsCreateCaseworkerTaskReducer,
  isFetchingPostVerificationsCreateCaseworkerTask: isFetchingPostVerificationsCreateCaseworkerTaskReducer,
  postVerificationsCreateCaseworkerTaskError: postVerificationsCreateCaseworkerTaskErrorReducer,
  documentsSubmitted: setDocumentsSubmittedReducer,
  form: setFormReducer
});
export default {
  reducers: reducers
};